import { getRequest } from 'utils/api/apiRequest'

export type VouchersLinksLb = {
  links?: string[]
}

export const getVouchersLinksLB = (webOrderReference: string) =>
  getRequest<VouchersLinksLb>(`/redemption-site/voucher-token/${webOrderReference}`)
